export default function ({ app }) {
  app.router.afterEach((to) => {
    app.$auth.$storage.setLocalStorage('latestRoute', to.fullPath)
  })
}
